import kissingbooth from '../../Images/placements/kissingbooth_1.jpg';
import love_victor from '../../Images/placements/love_victor_1.jpg';
import loveisland from '../../Images/placements/loveisland_2.jpeg';
import sellingsunset from '../../Images/placements/sellingsunset_1.jpg';
// import sellingtheoc from '../../Images/placements/sellingtheoc.jpeg';
import e80days from '../../Images/dvd_pic/80days_1.jpg';
import e80days_banner from '../../Images/banners/80days_banner_2.png';
import ukraine_banner from '../../Images/banners/ukraine_banner_2.png';
import ukraine from '../../Images/dvd_pic/ukraine_1.jpg';
import masterchef_3 from '../../Images/dvd_pic/masterchef_1.jpg';
import masterchef_banner from '../../Images/banners/masterchef_banner_2.png';
import hans_zimmer from '../../Images/collaborators/hans_zimmer.jpeg';
import stalled_the_musical from '../../Images/musical/stalled_the_musical.png';
import closure from '../../Images/placements/closure.jpg';
import lucifer from '../../Images/placements/lucifer_1.jpg';
import alaska from '../../Images/dvd_pic/alaska_1.jpg';
import balle_perdue from '../../Images/placements/balle_perdue_1.jpg';

import kissingbooth_song from '../../Audio/placements/kissingbooth.mp3';
import love_victor_song from '../../Audio/placements/love_victor.mp3';
import loveisland_song from '../../Audio/placements/loveisland.mp3';
import sellingsunset_song from '../../Audio/placements/sellingsunset.m4a';

// import sellingtheoc_song from '../../Audio/placements/sellingtheoc.m4a';

// import eighty_days_video from '../../Images/clips/80days_small.mp4';

const HomeData = [
	{
		id: 120,
		name: 'Hans Zimmer: Bleeding Fingers',
		director: 'Staring David Tennant',
		description: 'Andy scored this scene creating a feeling of x and y. The music moves through the scene with ...',
		info: ['Around The World In 80 Days (2022)','BBC','Bleeding Fingers','Additional Music'],
		thumbnail: hans_zimmer,
		thumbPos: {t:-40,l:0,size:1},
		banner: e80days_banner,
		brands: ['bbc','bleeding_fingers'],
		songs: [],
		// clips: [{name:'Around The World In 80 Days clip',video:eighty_days_video}],
		link: 'https://www.imdb.com/title/tt9174578/',
		navigation: '/film',
	},
	{
		id: 0,
		name: 'Around The World In 80 Days',
		director: 'Staring David Tennant',
		description: 'Andy scored this scene creating a feeling of x and y. The music moves through the scene with ...',
		info: ['Around The World In 80 Days (2022)','BBC','Bleeding Fingers','Additional Music'],
		thumbnail: e80days,
		thumbPos: {t:0,l:0,size:1},
		banner: e80days_banner,
		brands: ['bbc','bleeding_fingers'],
		songs: [],
		// clips: [{name:'Around The World In 80 Days clip',video:eighty_days_video}],
		link: 'https://www.imdb.com/title/tt9174578/',
		navigation: '/film',
	},
	{
		id: 0,
		name: 'Love Island',
		info: ['Love Island Song Placement','Peacock','Bleeding Fingers'],
		thumbnail: loveisland,
		// thumbPos: {t:90,l:0,size:1},
		thumbPos: {t:0,l:0,size:1},
		brands: ['peacock','bleeding_fingers'],
		videos: [],
		songs: [{name:'Andy Marsh: You & I',audio:loveisland_song}],
		navigation: '/placements',
	},
	{
		id: 1,
		name: 'Vox - Russia & Ukrainian War',
		director: '10 million+ views on Youtube',
		description: 'Andy scored this scene creating a feeling of x and y. The music moves through the scene with ...',
		info: [`Vox - Putin's war on Ukraine, explained`,'Vox Media','Youtube','Additional Music'],
		thumbnail: ukraine,
		thumbPos: {t:-4,l:0,size:1},
		// video: ukraine_clip,
		banner: ukraine_banner,
		brands: ['vox','youtube'],
		songs: [],
		// clips: [{name:'Vox - Russia & Ukrainian War',video:ukraine_clip}],
		clips: [],
		link: 'https://www.youtube.com/watch?v=MVu8QbxafJE&t=129s',
		navigation: '/film',
	},
	{
		id: 1,
		name: 'Kissing Booth 2',
		info: ['Kissing Booth 2','Netflix'],
		thumbnail: kissingbooth,
		thumbPos: {t:0,l:0,size:1},
		brands: ['netflix'],
		videos: [],
		songs: [{name:`Andy Marsh: You're My Air`,audio:kissingbooth_song}],
		navigation: '/placements',
	},
	{
		id: 6,
		name: 'Love, Victor',
		info: ['Love, Victor','Hulu',],
		thumbnail: love_victor,
		thumbPos: {t:0,l:0,size:1.01},
		brands: ['hulu'],
		videos: [],
		songs: [{name:'L.O.U.D, Kali J: Bum Bum',audio:love_victor_song}],
		navigation: '/placements',
	},
	{
		id: 3,
		name: 'Selling Sunset',
		info: ['Selling Sunset','Netflix',],
		thumbnail: sellingsunset,
		thumbPos: {t:0,l:0,size:1},
		brands: ['netflix'],
		videos: [],
		songs: [{name:'Andy Marsh: Do My Thang',audio:sellingsunset_song}],
		navigation: '/placements',
	},
	{
		id: 5,
		name: 'Master Chef',
		info: [`Master Chef (2021)`,`Fox`,`Bleeding Fingers`,`Additional Music`],
		thumbnail: masterchef_3,
		thumbPos: {t:0,l:0,size:1},
		banner: masterchef_banner,
		brands: ['masterchef','fox','bleeding_fingers'],
		songs: [],
		clips: [],
		link: '',
		navigation: '/film',
	},
	{
		id: 51,
		name: 'Stalled',
		info: [`Master Chef (2021)`,`Fox`,`Bleeding Fingers`,`Additional Music`],
		thumbnail: stalled_the_musical,
		thumbPos: {t:0,l:0,size:1},
		banner: stalled_the_musical,
		brands: ['masterchef','fox','bleeding_fingers'],
		songs: [],
		clips: [],
		link: '',
		navigation: '/musical',
	},
	{
		id: 12,
		name: 'Steve Void: Closure (feat. Andy Marsh)',
		info: ['Strange Fruits','Artist','Songwriter'],
		thumbnail: closure,
		thumbPos: {t:0,l:0,size:1.26},
		brands: ['strange_fruits'],
		videos: [],
		songs: [],
		spotify: '15 million',
		navigation: '/placements',
	},
	{
		id: 52,
		name: 'Lucifer',
		info: ['Lucifer','Netflix',],
		thumbnail: lucifer,
		thumbPos: {t:0,l:0,size:1},
		brands: ['netflix'],
		videos: [],
		songs: [],
		navigation: '/placements',
	},
	{
		id: 6,
		name: 'Alaskan Bush People',
		points: [],
		description: 'Alaskan Bush People is an American docudrama-style reality television series that follows the Brown family in an attempt to survive in the wilderness, detached from modern society.',
		info: [`Alaskan Bush People (2021)`,`Discovery`,`Bleeding Fingers`,`Park Slope Productions`,`Additional Music`],
		thumbnail: alaska,
		thumbPos: {t:0,l:0,size:1},
		banner: '',
		brands: ['discovery','bleeding_fingers'],
		songs: [],
		clips: [],
		navigation: '/film',
	},
	{
		id: 4,
		name: 'Balle Perdue 2 Trailer',
		info: ['Balle Perdue 2','Netflix',],
		thumbnail: balle_perdue,
		thumbPos: {t:0,l:0,size:1},
		brands: ['netflix'],
		videos: [],
		songs: [],
		navigation: '/placements',
	},
];

export default HomeData;